const APPOINT_INDIVIDUAL = "appointInd";
const CREATE_ACCOUNT = "createAcc";
const PHILAN_FUND = "philFund";
const MULTI_CHARITY = "multiCharity";
const ANNUAL_GRANT = "annualGrant";
const OTHERS = "others";
const PAGE_TITLE = "Edit Legacy Options";
const ERRORS = {
    default: {
        title: '',
        message: "We're sorry. We are unable to complete your request. Please try again."
    },
    userIdUpdateErr: {
        title: "It’s not you. It’s us!",
        message: "We are experiencing a technical error and we’re working on it. Please try again later."
    },
    myAccountPageErr: {
        title: "Uh-Oh!",
        message: "We’ve experienced a technical issue. Please try again."
    },
    editInterestedPartyErr:{
        title:"We've received your request to edit an Interested party.",
        message:"Please allow one business day for the update."
    },
    OAASubmitPageErr: {
        title: "We've received your request to open an additional account",
        message: "Please allow one business day for your new account to set up."
    }
}

export default {
    APPOINT_INDIVIDUAL,
    CREATE_ACCOUNT,
    PHILAN_FUND,
    MULTI_CHARITY,
    ANNUAL_GRANT,
    OTHERS,
    PAGE_TITLE,
    ERRORS
};